<template>
    <sidebar/>
</template>
<script>
import sidebar from './AppSdebar'
export default {
    components:{
        sidebar
    },
    data(){
        return{

        }
    }
}
</script>